import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { IInterval } from '../../interface/intervals'

export interface intervals {
    intervals: Array<IInterval>;
    toFinish: IInterval;
    loading: boolean;
    completionCheck: boolean;
    completeModal: boolean;
}

const initialState: intervals = {
    intervals: [],
    toFinish: { value: "", label: "" },
    loading: true,
    completionCheck: false,
    completeModal: false
}

export const intervalsSlice = createSlice({
    name: 'intervals',
    initialState,
    reducers: {
        setIntervals: (state, action: PayloadAction<Array<any>>) => {
            state.intervals = action.payload
        },

        setToFinish: (state, action: PayloadAction<IInterval>) => {
            state.toFinish = action.payload
        },

        setLoadingIntervalls: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload
        },

        setCompletionCheck: (state, action: PayloadAction<boolean>) => {
            state.completionCheck = action.payload
        },

        setCompleteModal: (state, action: PayloadAction<boolean>) => {
            state.completeModal = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { setIntervals, setToFinish, setLoadingIntervalls, setCompletionCheck, setCompleteModal } = intervalsSlice.actions

export default intervalsSlice.reducer